export const FAVICON_ALLOWED_SIZES = new Set([16, 32]);
export const FAVICON_MAX_BYTES = 1024 * 1024;
export const FAVICON_ACCEPT = '.ico,image/x-icon,image/vnd.microsoft.icon';

const ICON_MIME = new Set(['image/x-icon', 'image/vnd.microsoft.icon', 'image/ico', 'application/octet-stream', '']);

function parseIcoSizes(buffer) {
  const view = new DataView(buffer);
  if (view.byteLength < 6) {
    throw new Error('Arquivo .ico inválido ou corrompido.');
  }
  const reserved = view.getUint16(0, true);
  const type = view.getUint16(2, true);
  const count = view.getUint16(4, true);
  if (reserved !== 0 || type !== 1) {
    throw new Error('Use somente arquivo .ico. PNG, JPG e outros formatos não são aceitos.');
  }
  if (count < 1 || count > 16) {
    throw new Error('Favicon .ico inválido.');
  }
  if (view.byteLength < 6 + count * 16) {
    throw new Error('Arquivo .ico incompleto.');
  }
  const sizes = [];
  for (let i = 0; i < count; i += 1) {
    const off = 6 + i * 16;
    let width = view.getUint8(off);
    let height = view.getUint8(off + 1);
    if (width === 0) width = 256;
    if (height === 0) height = 256;
    sizes.push({ width, height });
  }
  return sizes;
}

export function validatePortalFaviconFile(file, arrayBuffer) {
  const name = String(file?.name || '').toLowerCase();
  if (!name.endsWith('.ico')) {
    return {
      ok: false,
      message: 'Use somente arquivo .ico. PNG, JPG e outros formatos não são aceitos.',
    };
  }
  const mime = String(file?.type || '').toLowerCase().split(';')[0].trim();
  if (!ICON_MIME.has(mime)) {
    return {
      ok: false,
      message: 'Tipo não permitido. Envie somente favicon .ico (16×16 ou 32×32).',
    };
  }
  if (!file?.size || file.size > FAVICON_MAX_BYTES) {
    return {
      ok: false,
      message: 'Tamanho inválido. O favicon .ico deve ter no máximo 1MB.',
    };
  }
  try {
    const sizes = parseIcoSizes(arrayBuffer);
    const invalid = sizes.filter(
      (item) => item.width !== item.height || !FAVICON_ALLOWED_SIZES.has(item.width)
    );
    if (invalid.length) {
      const found = [...new Set(sizes.map((item) => `${item.width}×${item.height}`))].join(', ');
      return {
        ok: false,
        message: `O favicon precisa ter 16×16 (recomendado) ou 32×32 pixels. Este arquivo tem ${found}.`,
      };
    }
    return { ok: true, sizes };
  } catch (error) {
    return { ok: false, message: error.message || 'Arquivo .ico inválido.' };
  }
}
